import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { isNil, isEmpty } from "lodash";

// SHARED
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

//HELPERS AND SERVICES
import { fetchPickUp, updateAssignDriver } from "Services/delivery.services";
import { decode } from "Helpers/enc";
import { listVehicles } from "Services/delivery-settings.services";
import { toaster } from "Helpers/index";
//SCSS
import "../parcel-tracking-view.scss";

// HOOKS
import useSession from "Hooks/session.hook";

import ParcelTrackingPickupViewComponent from "Components/delivery-management/parcel-tracking-view/pickup-view-component";
import { updateOrderDeliveryDate } from "Services/order.service";

const useParcelTrackingPickupViewPage = () => {
  const { id } = useParams<{ id: string }>();
  const decodedOrderID = decode(id);

  const [vehicleOptions, setVehicleOptions] = useState<any>([]);
  const [parcelDetails, setParcelDetails] = useState<any>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    fetchParcelDetails(decodedOrderID);
    handleListingVehicles();
  }, []);

  const handleListingVehicles = async () => {
    const responseData = await listVehicles({ active: true });
    setVehicleOptions(responseData);
  };

  const fetchParcelDetails = async (pickupID: any) => {
    const responseData = await fetchPickUp(pickupID);
    if (responseData && !responseData.error) {
      setParcelDetails(responseData);
    }
  };

  const handleAssignDriver = async (inputValue) => {
    const responseData = await updateAssignDriver(inputValue);

    if (!isNil(responseData) && responseData.updated) {
      toaster("success", "Assigned Driver successfully");
    } else {
      toaster("error", "Failed to update");
    }
  };

  const handleUpdateDeliveryDate = async (data) => {
    setIsLoading(true);

    const responseData = await updateOrderDeliveryDate(data);

    if (!responseData.error) {
      setIsLoading(false);
      setParcelDetails((prev) => ({
        ...prev,
        deliveryDate: data.deliveryDate,
      }));
      return true;
    } else {
      setIsLoading(false);
      return false;
    }
  };

  return {
    vehicleOptions,
    setVehicleOptions,
    parcelDetails,
    setParcelDetails,
    isLoading,
    setIsLoading,
    handleListingVehicles,
    fetchParcelDetails,
    handleAssignDriver,
    handleUpdateDeliveryDate,
  };
};

const ParcelTrackingPickupViewPage = ({}) => {
  const { t } = useTranslation();
  const { org, roleTypes } = useSession();

  const {
    isLoading,
    vehicleOptions,
    setVehicleOptions,
    parcelDetails,
    setParcelDetails,
    handleListingVehicles,
    fetchParcelDetails,
    handleAssignDriver,
    handleUpdateDeliveryDate,
  } = useParcelTrackingPickupViewPage();

  return (
    <div>
      <Helmet>
        <title>{t("title.deliveryManagement")}</title>
      </Helmet>

      <ModuleTitleBar
        titleText={t("title.deliveryManagement")}
        haveSubtitle
        subtitleText={t("title.pickupTask")}
      />
      {!isEmpty(parcelDetails) && (
        <ParcelTrackingPickupViewComponent
          parcelDetails={parcelDetails}
          vehicleOptions={vehicleOptions}
          onAssignDriver={handleAssignDriver}
          onUpdateDeliveryDate={handleUpdateDeliveryDate}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default ParcelTrackingPickupViewPage;
